import { formatMoney } from '../../../utils/format';

// Shared money formatter for every dashboard widget. Extracted in Phase 4 from the private
// copies in accountingWidgets/salesWidgets/expenseWidgets and the inline toLocaleString calls
// in inventoryWidgets/payrollWidgets. Output format is load-bearing: widget tests assert
// strings like '1,100.00', so any change here is a breaking change to those suites.

// The locale is pinned rather than left to the browser. With `undefined` the grouping and the
// digits followed whatever locale the viewer's browser reported, so the same figure rendered as
// '1,100.00' for one user, '1.100,00' for another, and in Bengali numerals with lakh/crore
// grouping under bn-BD — while every test (and the invoice PDF) assumed en-US. Money on the
// dashboard has to tie out against documents, so the format is fixed here.

/** The only currency this product bills and reports in (bKash/BDT, AmountInWords, invoice PDFs). */
export const CURRENCY_SYMBOL = '৳';

export function fmtMoney(n: number): string {
    return formatMoney(n);
}

/**
 * The calendar month BEFORE the current one from a zero-filled, oldest-first monthly series whose
 * last entry is the current month (the backend builds these in the caller's zone, so on the 1st
 * the current month is still empty and the previous month holds the figures that just closed).
 */
export function previousMonthEntry<T>(series: T[]): T | undefined {
    return series.length >= 2 ? series[series.length - 2] : undefined;
}
